import http from '@/utils/http-common'

export function changeAuthenticatedPassword(payload) {
  return http.post('account/change-password/', payload, {
    suppressGlobalErrorToast: true,
  })
}
